<template>
  <Chip
    v-if="content.launchData?.openedAt && !content.launchData?.completedAt"
    :size="ChipSize.SM"
    :variant="ChipVariant.FILLED"
    :icon="EyeSvg"
    :color="ChipColor.SECONDARY"
    class="w-fit self-end"
  >
    {{ $t('content.opened') }}
  </Chip>
  <Chip
    v-if="content.launchData?.completedAt"
    :size="ChipSize.SM"
    :variant="ChipVariant.FILLED"
    :icon="CheckSvg"
    :color="ChipColor.SUCCESS"
    class="w-fit self-end"
  >
    {{ $t('content.completed') }}
  </Chip>
</template>
<script setup lang="ts">
import { Chip, ChipColor, ChipSize, ChipVariant } from '~/components/chip';
import { ContentDto } from '~/api/contents';
import CheckSvg from '~/assets/icons/check.svg?component';
import EyeSvg from '~/assets/icons/eye.svg?component';

type Props = {
  content: ContentDto;
};

defineProps<Props>();
</script>
